import axios from 'axios';

import { TENANT } from 'constants/misc';

// eslint-disable-next-line no-template-curly-in-string
const LOCAL = process.env.REACT_APP_BASE_URL || '';

const isProd = process.env.NODE_ENV === 'production';
export const BASE_URL = (isProd ? '' : LOCAL).replace('#{tenantName}', TENANT);

export const setupAxios = () => {
  axios.interceptors.request.use((config) => {
    if (!config.url?.startsWith('./')) {
      const username: any = sessionStorage.getItem('principal');
      let newURL = config.url?.replace('{username}', username);

      Object.entries(config.pathParams || {})
        .filter((entries) => entries[1])
        .forEach(([key, value]) => {
          newURL = newURL?.replace(`:${key}`, encodeURIComponent(value));
        });

      if (newURL?.[0] === '/') {
        //TODO: remove this when secure is removed from endpoints
        config.url = `${BASE_URL}${newURL}`;
      } else {
        config.url = `${BASE_URL}/${newURL}`;
      }
    }

    const headers = config.headers || {};
    headers.Authorization = `Bearer ${sessionStorage.getItem('accessToken')}`;
    config.headers = headers;
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response.status === 401) {
        window._logoutDojo();
      }

      return Promise.reject(error);
    }
  );
};
